module.exports = __webpack_public_path__ + "static/movie-4c0c9b01dc8c5f3aefbc37c5d7a75454.jpg";